export const MATERIALS_PRESENTATION_VERSION_CONFLICT = 'MATERIALS_PRESENTATION_VERSION_CONFLICT';
export const MATERIALS_PRESENTATION_INVALID_CARD_REF = 'MATERIALS_PRESENTATION_INVALID_CARD_REF';
export const MATERIALS_PRESENTATION_DUPLICATE_CARD_REF = 'MATERIALS_PRESENTATION_DUPLICATE_CARD_REF';
export const MATERIALS_PRESENTATION_DUPLICATE_CATEGORY_NAME = 'MATERIALS_PRESENTATION_DUPLICATE_CATEGORY_NAME';
export const MATERIALS_PRESENTATION_CATEGORY_OVERLAP = 'MATERIALS_PRESENTATION_CATEGORY_OVERLAP';
export const MATERIALS_PRESENTATION_STATION_OVERRIDE_ONLY = 'MATERIALS_PRESENTATION_STATION_OVERRIDE_ONLY';
export const MATERIALS_PRESENTATION_COMPANY_EDIT_MANAGED_IN_WEB =
  'MATERIALS_PRESENTATION_COMPANY_EDIT_MANAGED_IN_WEB';

export const materialsPresentationErrorCodes = [
  MATERIALS_PRESENTATION_VERSION_CONFLICT,
  MATERIALS_PRESENTATION_INVALID_CARD_REF,
  MATERIALS_PRESENTATION_DUPLICATE_CARD_REF,
  MATERIALS_PRESENTATION_DUPLICATE_CATEGORY_NAME,
  MATERIALS_PRESENTATION_CATEGORY_OVERLAP,
  MATERIALS_PRESENTATION_STATION_OVERRIDE_ONLY,
  MATERIALS_PRESENTATION_COMPANY_EDIT_MANAGED_IN_WEB,
] as const;

export type MaterialsPresentationErrorCode = (typeof materialsPresentationErrorCodes)[number];
